import { createAction, props } from '@ngrx/store';
import { FetchArgs, PagingToken } from 'src/app/shared/models/core';
import { ComplianceFacility } from '../../models/compliance-facility.model';
import { ClientPortalVisibilityUpdate } from '../../models/client-portal-visibility-update.model';
import { DocDueDate } from '../../models/doc-due-date.model';
import { FacilityDocDueDates } from '../../models/facility-doc-due-dates.model';
import { Brand } from 'src/app/shared/models/brand';
import { Lookup } from 'src/app/shared/models/lookup.model';
import { ClientPortalVisibilitySettings } from '../../models/client-portal-visibility-settings.model';
import { ComplianceFacilityBulkEdit } from '../../models/compliance-facility-bulk-edit';
import { FacilityAutoMatchSettingsViewModel } from '../../models/facility-auto-match-settings-dto.model';

export const getFacility = createAction('[Facility Profile Component] Get Facility', props<{ id: number }>());

export const getFacilitySuccess = createAction(
    '[Facility Profile Component] Get Facility Success',
    props<{ facility: ComplianceFacility }>()
);

export const getFacilityFailure = createAction(
    '[Facility Profile Component] Get Facility Failure',
    props<{ error: unknown }>()
);

export const getFacilities = createAction('[Facilities Component] Get Facilities');

export const getFacilitiesSuccess = createAction(
    '[Facilities API] Get Facilities Success',
    props<{ facilities: PagingToken<ComplianceFacility[]> }>()
);

export const getFacilitiesFailure = createAction(
    '[Facilities API] Get Facilities Failure',
    props<{ error: unknown }>()
);

export const setFacilitiesFilter = createAction(
    '[Facilities Component] Set Facilities Filter',
    props<{ filter: FetchArgs }>()
);

export const getFacilityClientPortalVisibilitySettings = createAction(
    '[CLIENT PORTAL VISIBILITY COMPONENT] Get Facility Client Portal Visibility Settings',
    props<{ id: number }>()
);
export const getFacilityClientPortalVisibilitySettingsSuccess = createAction(
    '[Facilities API] Get Facility Client Portal Visibility Settings Success',
    props<{ clientPortalVisibilitySettings: ClientPortalVisibilitySettings }>()
);
export const getFacilityClientPortalVisibilitySettingsFailure = createAction(
    '[Facilities API] Get Facility Client Portal Visibility Settings Failure',
    props<{ error: unknown }>()
);

export const updateFacilityClientPortalVisibilitySettings = createAction(
    '[CLIENT PORTAL VISIBILITY COMPONENT] Update Facility Client Portal Visibility Settings',
    props<{ id: number; updates: ClientPortalVisibilityUpdate[] }>()
);
export const updateFacilityClientPortalVisibilitySettingsSuccess = createAction(
    '[Facilities API] Update Facility Client Portal Visibility Settings Success',
    props<{ id: number }>()
);
export const updateFacilityClientPortalVisibilitySettingsFailure = createAction(
    '[Facilities API] Update Facility Client Portal Visibility Settings Failure',
    props<{ error: unknown }>()
);

export const getDocDueDate = createAction(
    '[FACILITY REQUIREMENTS COMPONENT] Get Doc Due Date ',
    props<{ id: number }>()
);
export const getDocDueDateSuccess = createAction(
    '[Facilities API] Get Doc Due Date Success',
    props<{ docDueDate: FacilityDocDueDates }>()
);
export const getDocDueDateFailure = createAction(
    '[Facilities API] Get Doc Due Date Failure',
    props<{ error: unknown }>()
);

export const updateDocDueDate = createAction(
    '[FACILITY REQUIREMENTS COMPONENT] Update Doc Due Date',
    props<{ id: number; docDueDate: DocDueDate }>()
);
export const updateDocDueDateSuccess = createAction(
    '[Facilities API] Update Doc Due Date Success',
    props<{ id: number }>()
);
export const updateDocDueDateFailure = createAction(
    '[Facilities API] Update Doc Due Date Failure',
    props<{ error: unknown }>()
);
export const updateFacilityCompleteStatus = createAction(
    '[Facilities API] Update Complete Status',
    props<{ facility: ComplianceFacility }>()
);
export const updateFacilityCompleteStatusSuccess = createAction(
    '[Facilities API] Update Complete Status Success',
    props<{ id: number }>()
);
export const updateFacilityCompleteStatusFailure = createAction(
    '[Facilities API] Update Complete Status Failure',
    props<{ error: unknown }>()
);
export const updateFacilityBulkCompleteStatus = createAction(
    '[Facilities API] Bulk Update Complete Status',
    props<{ bulkEdit: ComplianceFacilityBulkEdit }>()
);
export const updateFacilityBulkCompleteStatusSuccess = createAction(
    '[Facilities API] Bulk Update Complete Status Success',
    props<{ id: number[] }>()
);

export const updateFacilityBulkAutoMatchStatusSuccess = createAction(
    '[Facilities API] Bulk Update Auto Match Success',
    props<{ id: number[] }>()
);

export const updateFacilityBulkCompleteStatusFailure = createAction(
    '[Facilities API] Bulk Update Complete Status Failure',
    props<{ error: unknown }>()
);

export const getBrands = createAction('[Facility Component] Get Brands');

export const getBrandsSuccess = createAction('[Facility Component] Get Brands Success', props<{ brands: Brand[] }>());

export const getBrandsFailure = createAction('[Facility Component] Get Brands Failure', props<{ error: unknown }>());

export const getVmsLookups = createAction('[Facility Component] Get VMS Lookups', props<{ searchText: string }>());

export const getVmsLookupsSuccess = createAction(
    '[Facility Component] Get VMS Lookups Success',
    props<{ vmsLookups: Lookup[] }>()
);

export const getVmsLookupsFailure = createAction(
    '[Facility Component] Get VMS Lookups Failure',
    props<{ error: unknown }>()
);

export const getFacilityAutomatchSettings = createAction(
    '[FACILITY COMPONENT] Get Automatch Settings For Facility',
    props<{ facilityId: number }>()
);

export const getFacilityAutomatchSettingsSuccess = createAction(
    '[FACILITY API] Get Automatch Settings For Facility Success',
    props<{ settings: FacilityAutoMatchSettingsViewModel }>()
);

export const getFacilityAutomatchSettingsFailure = createAction(
    '[FACILITY API] Get Automatch Settings For Facility Failure',
    props<{ error: unknown }>()
);

export const updateFacilityAutomatchSettings = createAction(
    '[FACILITY COMPONENT] Update Automatch Settings For Facility',
    props<{ settings: FacilityAutoMatchSettingsViewModel }>()
);

export const updateFacilityAutomatchSettingsSuccess = createAction(
    '[FACILITY API] Update Automatch Settings For Facility Success',
    props<{ settings: FacilityAutoMatchSettingsViewModel }>()
);

export const updateFacilityAutomatchSettingsFailure = createAction(
    '[FACILITY API] Update Automatch Settings For Facility Failure',
    props<{ error: unknown }>()
);

export const clearLocalFacilityAutomatchSettings = createAction(
    '[FACILITY COMPONENT] Clear Local Facility Automatch Settings'
);
